import { FC } from 'react';
import MuiMenuItem from '@mui/material/MenuItem';
import { IMenuItemProps } from './types';

export const MenuItem: FC<IMenuItemProps> = props => <MuiMenuItem {...props} />;
